var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"bottom","content-class":"tooltip--long"}},[_c('v-icon',{attrs:{"slot":"activator","dark":"dark","color":"secondary"},slot:"activator"},[_vm._v("info_outline")]),_c('span',[_vm._v(_vm._s(_vm.C.data.message))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d7d608","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventions/BasicTooltip.vue
// module id = yTgj
// module chunks = 1